import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    title: 'Easy, Reliable, and Instant: Ways to apply for a loan in Kredit Pintar',
    title1: 'Download Kredit Pintar application via Google Play Store and Apple Store',
    title2:
      'Register your account in Kredit Pintar application and fulfill your personal data according to the given instructions',
    title3: 'Apply for a loan based on the available nominal',
    title4: 'Wait for the loan approval',
    title5: 'Your money will be directly disbursed within 1 x 24 hours after the approval is received',
    desc1: 'Just click and submit',
    desc2: 'To ensure validity, security, and credibility',
    desc3: 'Fast process, borrow money only 5 minutes!',
    desc4: 'To make it easier for you',
    desc5: 'Licensed, Monitored & Supervised by OJK',
  },
  id: {
    title: 'Mudah, Aman, dan Cepat: Inilah cara pinjam uang di Kredit Pintar',
    title1: 'Unduh atau download aplikasi Kredit Pintar melalui Google Play Store dan Apple Store',
    title2: 'Lakukan registrasi di aplikasi Kredit Pintar dan isi data diri sesuai petunjuk yang diberikan',
    title3: 'Ajukan pinjaman sesuai dengan pilihan nominal yang tersedia',
    title4: 'Tunggu persetujuan pengajuan pinjaman',
    title5: 'Dana akan cair ke rekening dalam 1x24 jam setelah persetujuan pinjaman diterima',
    desc1: 'Tinggal click dan submit',
    desc2: 'Memastikan validitas, keamanan, dan kredibilitas',
    desc3: 'Proses cepat, pinjam uang cuma 5 menit!',
    desc4: 'Untuk memudahkan anda',
    desc5: 'Berizin, Terdaftar & Diawasi oleh OJK',
  },
})

const EasyProces = () => {
  const { width } = useWindowSize()
  const { t } = useResource(resource)
  const IconList = [
    {
      img: '/images/product/proces1.png',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/images/product/proces2.png',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/images/product/proces3.png',
      title: t('title3'),
      desc: t('desc3'),
    },
    {
      img: '/images/product/proces4.png',
      title: t('title4'),
      desc: t('desc4'),
    },
    {
      img: '/images/product/proces5.png',
      title: t('title5'),
      desc: t('desc5'),
    },
  ]
  return (
    <EasyStyle>
      <div className="title">{t('title')}</div>
      <div className="container">
        <div className="left">
          {IconList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 30} animation={Animation.FadeIn}>
              <div className="items">
                <LazyLoad>
                  <img className="item-img" src={item.img} alt={item.title} />
                </LazyLoad>
                <div className="item-text">
                  <div className="des subtitle">{item.title}</div>
                  {/* <div className="des">{item.desc}</div> */}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="right">
          <div className="video-box">
            <LazyLoad>
              <iframe
                loading="lazy"
                width={width > 1000 ? 420 : 320}
                height={width > 1000 ? 250 : 192}
                src="https://www.youtube.com/embed/oRNCkprO5qY"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </LazyLoad>
          </div>
        </div>
      </div>
    </EasyStyle>
  )
}

export default EasyProces

const EasyStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    /* margin: 96px auto 64px; */
    text-align: center;
    /* width: 100%; */
    /* padding: 0 16px; */
    padding: 0 24px;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 40px;
    }
    .container {
      .left {
        .items {
          margin-bottom: 32px;
          .item-img {
            width: 56px;
            height: 56px;
          }
          .item-text {
            text-align: center;
            .subtitle {
              padding-top: 12px;
            }
          }
        }
      }
      .right {
        margin: 0 auto;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 90px 150px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 40px;
    }
    .container {
      display: flex;
      justify-content: space-between;
      .left {
        width: 624px;
        .items {
          display: flex;
          align-items: center;
          margin-bottom: 32px;
          .item-img {
            width: 56px;
            height: 56px;
          }
          .item-text {
            text-align: left;
            padding-left: 8px;
          }
        }
      }
      .right {
        margin-top: -2px;
        .video-box {
          width: 420px;
          height: 250px;
        }
      }
    }
  }
  .des {
    font-size: 24px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }
`
